/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-west-1",
    "aws_cognito_identity_pool_id": "us-west-1:9f5e01a9-cd81-4d91-b002-537a8fbb61e3",
    "aws_cognito_region": "us-west-1",
    "aws_user_pools_id": "us-west-1_uCFhlMPUt",
    "aws_user_pools_web_client_id": "mbq6370r67ajope7v9didsr9i",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "sharpmenuingredientinsights180132-dev",
    "aws_user_files_s3_bucket_region": "us-west-1",
    "aws_cognito_login_mechanisms": []
};


export default awsmobile;
